<script setup lang="ts">
import FormEspacoEvento from '../components/form-espacoevento.vue'
import { useEspacoEventoStore } from '../store/useEspacoEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-espaco-evento',
    action: 'create',
    subject: 'espaco-evento',
  },
})

const { resetForm } = useEspacoEventoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormEspacoEvento />
</template>
